// extracted by mini-css-extract-plugin
export default {"voucherWrapper":"VWEyJO","voucherCard":"IhHegd","offer":"L9BoA7","tooltip":"S6iHuK","tooltipTrigger":"D4tdOG"};